import(/* webpackMode: "eager" */ "/home/runner/work/mira-network/mira-network/playground_v2/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/mira-network/mira-network/playground_v2/src/app/Root.tsx");
